import {FormattedMessage} from 'react-intl'
import {AsideMenuItem} from '../AsideMenuItem'
import {useMenuPermission} from '../../../../helpers/hooks/menuHook'

const BuyoutsMenu = () => {
  const {filterMenuItems, isMenuItemAllowed} = useMenuPermission()
  return (
    <>
      {isMenuItemAllowed('GENERAL.ASIDE_MENU.BUYOUTS_SECTION') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-gray-300 fw-bold text-uppercase fs-8 ls-1'>
              <FormattedMessage id='GENERAL.ASIDE_MENU.BUYOUTS_SECTION' />
            </span>
            </div>
          </div>

          {filterMenuItems(menuItems).map((item, index) => (
            <AsideMenuItem
              key={index}
              to={item.to}
              title={item.title}
              fontIcon={item.fontIcon}
              icon={item.icon}
            />
          ))}
        </>
      )}
    </>
  )
}

export default BuyoutsMenu

const menuItems = [
  {
    to: '/buyouts/list',
    title: 'GENERAL.ASIDE_MENU.BUYOUTS_LIST_TITLE',
    fontIcon: 'bi-archive',
    icon: '/media/icons/duotune/ecommerce/ecm005.svg',
  },
  {
    to: '/buyouts/create',
    title: 'GENERAL.ASIDE_MENU.BUYOUTS_ADD_TITLE',
    icon: '/media/icons/duotune/general/gen041.svg',
    fontIcon: 'bi-person',
  },
]
